<template>
  <div id="app"
       v-if="data!=null">

    <div class="flex  bg-white margin-center align-center font-size-14 font-color-black top">
      <span @click="tohome">首页 &nbsp&nbsp</span> /<span @click="toArticle">&nbsp&nbsp{{data.ChannelName}}&nbsp&nbsp</span> /<span>&nbsp&nbsp正文&nbsp&nbsp</span>
    </div>
    <div class="flex justify-between bg-white margin-center"
         style="width:1220px">
      <div class="backgroud">
        <p style="margin-top:52px;padding: 0 53px; "
           class="font-size-22 font-color-black text-line ">{{data.Title}}</p>

        <span class="flex font-color-999 font-size-12"
              style="margin-top:19px">{{data.CreateTime}} 出处：{{data.Media}}</span>
        <div style=" border-bottom: #eeeeee dashed 1px; width: 100%; margin-top:20px"></div>
        <!-- v-html="html" -->
        <div style="padding: 36px 0px;text-align:left;overflow: hidden;width: 694px;"
             class="font-size-16 text-line-bg"
             v-html="data.Content">
        </div>
      </div>
      <div class="flex flex-direction backgroud1">
        <p style="line-height:63px;color:#4C4948;margin-left:20px"
           class="font-size-20 ">推荐资讯</p>
        <div style=" border-bottom: #eeeeee dashed 1px; width: 100%;margin: 0 0 10px;"></div>
        <div class="flex itemIndex align-center"
             @click="clickItem(item.Id)"
             v-for="(item, index) in items">
          <img src="../../assets/img/list.png"
               style="width:8px;height:8px"
               alt="">
          <p style="flex:1;padding:0 7px"
             class="text-line1">{{item.Title}}</p>

        </div>
      </div>
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>
import common from '@/utils/common.js'
export default {
  name: 'app',

  data () {
    return {
      items: [],
      id: 0,
      data: null
    }
  },

  mounted () {
    this.id = this.$route.query.Id || 0
    this.getDeTail()
    // this.getRecommendArticles();
    // if (this.id == 0) {
    //   this.$router.push({ name: 'home' })
    // }
  },

  methods: {
    toArticle () {
      this.$router.push({
        name: 'information',
        params: {
          ChannelId: this.data.ChannelId
        }
      })
    },
    tohome () {
      this.$router.push({
        name: 'home'
      })
    },
    getDeTail () {
      var that = this

      this.getRequest('api/v1/authorinfo/GetDetails', {
        Id: this.id
      }).then(data => {
        if (data.IsSuccess) {
          data.Data.CreateTime = common.formatDateYMD(data.Data.CreateTime).allDatatime
          that.data = data.Data
          that.getRecommendArticles(data.Data.ChannelId)
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    getRecommendArticles (ChannelId) {
      var that = this

      this.getRequest('api/v1/authorinfo/GetRecommendArticles', {
        ChannelId: ChannelId,
        Id: this.id,
        limit: 5
      }).then(data => {
        if (data.IsSuccess) {
          that.items = data.Data
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    clickItem (Id) {
      // this.$route.query.Id = Id;
      // this.id = Id;
      // this.getDeTail()
      this.$router.replace({ path: '/infordes', query: { 'Id': Id } })
      this.id = Id
      this.getDeTail()
    }
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}
.top {
  width: 1220px;
  height: 58px;
}
.top span {
  cursor: pointer;
}
.top span:hover {
  color: #d30000;
}
.backgroud {
  width: 800px;
  min-height: 200px;
  background: #ffffff;
  display: flex;
  flex-direction: column;

  align-items: center;
  border-top: #d30000 solid 4px;
  box-shadow: 0px 3px 20px 0px #ececec;
}

.backgroud1 {
  width: 401px;
  flex-direction: column;
  align-items: flex-start;
  height: 250px;
  background: #ffffff;
  border-top: #d30000 solid 4px;
  box-shadow: 0px 3px 20px 0px #ececec;
}
.information {
  box-sizing: border-box;
  width: 1159px;
  padding: 20px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-bottom: #eeeeee dashed 1px;
}
.itemIndex {
  width: 100%;
  height: 31px;
  font-size: 14px;
  padding: 0 17px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  cursor: pointer;
  line-height: 31px;
}
.itemIndex:hover {
  color: #d30000;
}
</style>



// WEBPACK FOOTER //
// src/views/information/des.vue